import axios from 'axios';

import cookie from '@/app/plugins/Cookie';
import config from '@/app/config';
import router from '@/app/router';
import { createLocalStorage } from '@/app/utils/LocalStorage';

const storage = createLocalStorage(config);
class AxiosPlugin {
  constructor() {
    this.instance = axios.create({
      baseURL: config.API_URL,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
        // 'Content-Type': 'application/json'
      },
    });

    this.instance.interceptors.request.use((axiosConfig) => {
        if (cookie.getCookie('api_token')) {
          axiosConfig.headers.Authorization = 'Bearer ' + cookie.getCookie('api_token');
        }

        const loja = storage.get('loja');
        if (loja) {
          axiosConfig.headers['x-loja-id'] = loja.id;
        }

        return axiosConfig;
      },
      (error) => Promise.reject(error)
    );

    this.instance.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status == 401) {
          router.push('/login');
        }
        return Promise.reject(error);
      }
    );
  }

  install(Vue, options) {
    Vue.prototype.$axios = this.instance;
  }
}

const axiosPlugin = new AxiosPlugin();

export { axiosPlugin };

export default axiosPlugin.instance;
